export const REVIEWS_PER_PAGE = 25;
export const REVIEWS_FOR_PAGE_1 = 50; // New GraphQL API has a limit of 60 reviews. Making this 50 to be a multiple of 25
export const pageAfterFirst =
	Math.floor(REVIEWS_FOR_PAGE_1 / REVIEWS_PER_PAGE) + 1;

export const REVIEW_AI_SUMMARY_MINIMUM_AVERAGE_RATING = 4.1;
export const REVIEW_AI_SUMMARY_MINIMUM_REVIEW_COUNT = 5;
